export const TYPES = {
  GET_ALL_BRANCHES: "branch/GET_ALL_BRANCHES",
  GET_BRANCH_DETAIL_BY_SLUG: "branch/GET_BRANCH_DETAIL_BY_SLUG",
};
